import React, { useEffect, useState } from 'react'
import EmployerDashboardNav from '../../employer/EmployerDashboardNav'
import CompanyDetails from '../../employer/CompanyDetails'
import CreateCompany from './CreateCompany';
import axios from 'axios';
import { useNavigate } from 'react-router';
import CompanyUpdateDetails from '../../employer/CompanyUpdateDetails';
import Breadcrumb from '../../Breadcrumb';

const CompanyProfile = () => {
  const [loading, setLoading] = useState(true);
  const [companyProfile, setCompanyProfile] = useState(null);
  const [availability, setAvailability] = useState(0);
  const [editMode, setEditMode] = useState(false);
  const [showButtons, setShowButtons] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const companyId = localStorage.getItem("companyId");

  const getCompanyByCompanyId = async () => {
    setLoading(true);
    setError(null);
    try {
      const url = `${process.env.REACT_APP_API_URL}companyDetails/bycompanyid/${companyId}`;
      const response = await axios.get(url);
      if (response.data && Object.keys(response.data).length > 0) {
        setAvailability(1);
        setShowButtons(true)
        setCompanyProfile(response.data[0]);
      } else {
        setAvailability(2);
      }
    } catch (error) {
      setError("Failed to load data. Please try again later.");
      console.error(error);
      setAvailability(0);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getCompanyByCompanyId();
  }, [companyId]);
  return (
    <>
      {/* <div className="site-breadcrumb">
        <div className="container">
          <h2 className="breadcrumb-title">Company Profile</h2>
          <ul className="breadcrumb-menu">
            <li>
              <a href="index.html">Home</a>
            </li>
            <li className="active">Company Profile</li>
          </ul>
        </div>
        <div className="hero-shape">
          <img
            loading="lazy"
            role="presentation"
            decoding="async"
            fetchPriority="high" className="hero-shape-1" src="assets/img/shape/03.svg" alt="" />
          <img
            loading="lazy"
            role="presentation"
            decoding="async"
            fetchPriority="high" className="hero-shape-2" src="assets/img/shape/05.svg" alt="" />
          <img
            loading="lazy"
            role="presentation"
            decoding="async"
            fetchPriority="high" className="hero-shape-3" src="assets/img/shape/06.svg" alt="" />
          <img
            loading="lazy"
            role="presentation"
            decoding="async"
            fetchPriority="high" className="hero-shape-4" src="assets/img/shape/07.svg" alt="" />
        </div>
      </div> */}
      <Breadcrumb
        title="Company Profile"
        path={[
          { label: "Home", href: "/", active: false },
          { label: "Company Profile", active: true }
        ]}
      />
      <div className='user-profile py-120'>
        <div className='container'>
          <div className='row'>
            <EmployerDashboardNav />
            {loading ? (
              <div className="text-center py-5">
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
                <p className="mt-2">Loading company profile...</p>
              </div>
            ) : (
              <>
                {(availability === 0) && error && <span className="alert alert-danger text-center w-75 h-25">{error}</span>}
                {(availability === 1) && !editMode && <CompanyDetails companyProfile={companyProfile} />}
                {(availability === 2) && <CreateCompany companyId={companyId} refreshCompanyData={getCompanyByCompanyId} />}
                {editMode && <CompanyUpdateDetails setEditMode={setEditMode} companyProfile={companyProfile} refreshCompanyData={getCompanyByCompanyId} />}
                {
                  showButtons && !editMode && !loading && (
                    <div className="d-flex justify-content-center mt-3">
                      <button
                        className="btn btn-warning mx-2"
                        onClick={() => {
                          setEditMode(true);
                          window.scrollTo(0, 0);
                        }}
                      >
                        <i className="fa-solid fa-edit me-1"></i>Edit Information
                      </button>
                    </div>
                  )
                }
              </>
            )}
          </div>
        </div>
      </div>
    </>
  )
}

export default CompanyProfile